<div class="unlinked">
  <p class="unlinked-lead">
    Multas que chegaram na placa de um veículo do contrato e ainda não foram atreladas a ele. Isso fica só no ERP.
  </p>

  <div *ngIf="loading" class="unlinked-state">Carregando…</div>
  <div *ngIf="!loading && error" class="alert alert-danger">{{ error }}</div>

  <ng-container *ngIf="!loading && !error">
    <div class="unlinked-bar">
      <strong>{{ total }} multa(s)</strong>
      <input type="text" class="form-control" [(ngModel)]="filtro" placeholder="Filtrar AIT, placa ou empresa" />
    </div>

    <p *ngIf="total > itens.length" class="unlinked-note">
      Mostrando as {{ itens.length }} mais recentes de {{ total }}.
    </p>

    <div *ngIf="visiveis.length === 0" class="unlinked-state">Nenhuma multa nessa situação.</div>

    <table *ngIf="visiveis.length > 0" class="table unlinked-table">
      <thead>
        <tr>
          <th><button type="button" class="sort-btn" (click)="ordenar('aipNumber')">AIT{{ seta('aipNumber') }}</button></th>
          <th><button type="button" class="sort-btn" (click)="ordenar('placa')">Placa{{ seta('placa') }}</button></th>
          <th><button type="button" class="sort-btn" (click)="ordenar('contratante')">Empresa{{ seta('contratante') }}</button></th>
          <th><button type="button" class="sort-btn" (click)="ordenar('infractionDateTime')">Data da infração{{ seta('infractionDateTime') }}</button></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of visiveis" class="unlinked-row" (click)="abrir(item)">
          <td>
            <a class="unlinked-link" [routerLink]="['/financial/traffic-fines', item.id, 'view']" (click)="$event.stopPropagation()">
              {{ item.aipNumber }}
            </a>
          </td>
          <td>{{ item.placa || '—' }}</td>
          <td>{{ item.contratante || '—' }}</td>
          <td>{{ item.infractionDateTime ? (item.infractionDateTime | date:'dd/MM/yyyy HH:mm') : '—' }}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>
